export const getNickNameFromLocalStorage = ()=>{
    const jsonStr = localStorage.getItem('userInfo')||''
    const jsonObj = JSON.parse(jsonStr)
    const name = jsonObj.nickname
    return name
}
// 将数字转化为中文表示的方法
export const numberToChinese=(money:any)=>{
   var cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
   var cnIntRadice = ['', '拾', '佰', '仟']
   var cnIntUnits = ['', '万', '亿', '兆']
   var cnDecUnits = ['角', '分', '毫', '厘']
   var cnInteger = '整'
   var cnIntLast = '元'
   var maxNum = 999999999999999.9999
   var integerNum
   var decimalNum
   var chineseStr = ''
   var parts
   if (money === '') {
     return ''
   }
   money = parseFloat(money)
   if (money >= maxNum) {
     return ''
   }
   if (money === 0) {
     chineseStr = cnNums[0] + cnIntLast + cnInteger
     return chineseStr
   }
   money = money.toString()
   if (money.indexOf('.') === -1) {
     integerNum = money
     decimalNum = ''
   } else {
     parts = money.split('.')
     integerNum = parts[0]
     decimalNum = parts[1].substr(0, 4)
   }
   if (parseInt(integerNum, 10) > 0) {
     var zeroCount = 0
     var IntLen = integerNum.length
     for (var i = 0; i < IntLen; i++) {
       var n = integerNum.substr(i, 1)
       var p = IntLen - i - 1
       var q = p / 4
       var m = p % 4
       if (n === '0') {
         zeroCount++
       } else {
         if (zeroCount > 0) {
           chineseStr += cnNums[0]
         }
         zeroCount = 0
         chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
       }
       if (m === 0 && zeroCount < 4) {
         chineseStr += cnIntUnits[q]
       }
     }
     chineseStr += cnIntLast
   }
   if (decimalNum !== '') {
     var decLen = decimalNum.length
     for (i = 0; i < decLen; i++) {
       n = decimalNum.substr(i, 1)
       if (n !== '0') {
         chineseStr += cnNums[Number(n)] + cnDecUnits[i]
       }
     }
   }
   if (chineseStr === '') {
     chineseStr += cnNums[0] + cnIntLast + cnInteger
   } else if (decimalNum === '') {
     chineseStr += cnInteger
   }
   return chineseStr
 }


 export const getStatusType = (status:string) => {
  switch (status) {
    case "A":
      return "primary";
    case "B":
      return "info";
    case "C":
      return "danger";
    case "D":
      return "danger";
    case "E":
      return "danger";
    case "F":
      return "danger";
    case "G":
      return "info";
    case "H":
      return "info";
    case "I":
      return "info";
    case "k":
      return "info";
    case "Y":
      return "info";
    default:
      return "info";
  }
};
export const getStatusContent = (status:string) => {
  switch (status) {
    case "A":
      return "正常";
    case "B":
      return "不动户";

    case "C":
      return "销户";
    case "D":
      return "久悬户";
    case "E":
      return "封闭冻结";
    case "F":
      return "金额冻结";
    case "G":
      return "未启用";
    case "H":
      return "待启用";
    case "I":
      return "转营业外收入";
    case "k":
      return "预开户";
    case "Y":
      return "预销户";
    default:
      return "";
  }
};

export const getJiaoyiStatusContent = (status:string) => {
  switch (status) {
    case "F":
      return ["失败",'error'];
    case "S":
      return ["成功",'primary'];

    case "U":
      return ["超时",'info'];
    case "2":
      return ["初始化",'info'];
    
    default:
      return ["",'info'];
  }
};

export const getUniqueString = ()=>{
  const uniqueString = Math.random().toString(36).substring(2);
  return uniqueString;

}